import GridSectionApp from "./App.vue";
import { createApp } from "vue";

const app = createApp(GridSectionApp);
app.mount("#app");
